import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { siteInfo } from "@/mocks/siteInfo";

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-2xl text-primary-400 font-bold whitespace-nowrap">
              51黑料网
            </Link>
            <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
              {siteInfo.slogan}
            </p>
            <p className="mt-2 text-xs text-foreground-500">
              聚合每日最新黑料与八卦爆料，快速获取新鲜黑料内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-200 mb-4">热门分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-200 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about#reputation" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  口碑声誉
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/about#faq" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  常见问题
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-200 mb-4">联系方式</h4>
            <ul className="space-y-2 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>{siteInfo.phone}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line"></i>
                <span>{siteInfo.wechat}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 京ICP备2024XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">
              用户协议
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}